import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Table from '@material-ui/core/Table'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
const styles = theme => ({})
const SyncCircle = ({ isSync, deleting }) => {
  return (
    <div
      style={{
        backgroundColor:
          isSync && !deleting ? 'green' : deleting ? 'orange' : 'red',
        borderRadius: '50%',
        width: 10,
        height: 10,
        alignSelf: 'center',
        marginRight: 2
      }}
    />
  )
}
class ProductsTableComponent extends Component {
  static propTypes = {
    products: PropTypes.array.isRequired,
    paidProducts: PropTypes.array.isRequired,
    payments: PropTypes.array.isRequired,
    onSelectProduct: PropTypes.func,
    onUnselectProduct: PropTypes.func,
    onSelectAllProducts: PropTypes.func
  }
  state = {
    selectedProducts: [],
    numSelected: 0,
    selectableCount: 0
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.payments &&
      this.props.payments &&
      nextProps.payments.length !== this.props.payments.length
    ) {
      const selectableCount =
        nextProps.products.length - nextProps.paidProducts.length
      this.setState({ selectedProducts: [], selectableCount: selectableCount })
    }
  }
  componentDidMount() {
    const { products, paidProducts } = this.props
    const selectableCount = products.length - paidProducts.length
    this.setState({ selectableCount: selectableCount })
  }
  isSelected = key => !!this.state.selectedProducts.find(p => p.key === key)
  isAlreadyPaid = key => !!this.props.paidProducts.find(p => p === key)

  handleProductClick = (e, product, isDisabled) => {
    if (isDisabled) {
      return
    }
    const { selectedProducts } = this.state
    let newSelProducts = [...selectedProducts]
    if (selectedProducts.find(p => p.key === product.key)) {
      this.props.onUnselectProduct(product)
      _.remove(newSelProducts, { key: product.key })
    } else {
      newSelProducts = [...this.state.selectedProducts, product]
      this.props.onSelectProduct(product)
    }
    this.setState({
      selectedProducts: newSelProducts,
      numSelected: newSelProducts.length
    })
  }
  onSelectAllClick = (event, checked) => {
    let selectedProducts = []
    if (checked) {
      const { products } = this.props
      selectedProducts = products.filter(p => !this.isAlreadyPaid(p.key))
    }
    this.props.onSelectAllProducts(selectedProducts)
    this.setState({
      selectedProducts: selectedProducts,
      numSelected: selectedProducts.length
    })
  }
  render() {
    const { products } = this.props
    const { selectableCount, numSelected } = this.state
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                disabled={selectableCount === 0}
                indeterminate={
                  selectableCount === 0 ||
                  (numSelected > 0 && numSelected < selectableCount)
                }
                checked={numSelected !== 0 && numSelected === selectableCount}
                onChange={this.onSelectAllClick}
              />
            </TableCell>
            <TableCell numeric={false} padding="none">
              Nom
            </TableCell>
            <TableCell numeric>Prix</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map(p => {
            const isSelected = this.isSelected(p.key)
            const isDisabled = this.isAlreadyPaid(p.key)
            return (
              <TableRow
                hover
                onClick={event => this.handleProductClick(event, p, isDisabled)}
                role="checkbox"
                aria-checked={isSelected}
                tabIndex={-1}
                key={p.key}
                disabled={isDisabled}
                selected={isSelected}>
                <TableCell padding="checkbox">
                  <Checkbox
                    disabled={isDisabled}
                    checked={isSelected}
                    indeterminate={isDisabled}
                  />
                </TableCell>
                <TableCell padding="none">
                  <div style={{ display: 'inline-flex' }}>
                    <SyncCircle
                      isSync={!!p.id_sale_product_detail}
                      deleting={p.deletedBy}
                    />
                    <Typography>{p.name}</Typography>
                  </div>
                </TableCell>
                <TableCell numeric>{Number(p.price).toFixed(2)}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(ProductsTableComponent)



// WEBPACK FOOTER //
// ./src/components/payment/ProductsTableComponent.js